// extracted by mini-css-extract-plugin
module.exports = {"excerpt":"styles_excerpt__1kNBP"};